/**
 * Códigos oficiais eSocial (leiaute v_S_01_03_00).
 *
 * Estas tabelas vêm dos Anexos I e II do MOS (Manual de Orientação do eSocial)
 * e são usadas pelos dropdowns dos formulários de geração de eventos.
 *
 * 🔜 Próxima fase: estes códigos virão de uma collection paramétrica
 * `esocial_codigos` no MongoDB, permitindo ao usuário cadastrar/customizar.
 * Enquanto isso, mantemos hardcoded para garantir funcionamento imediato.
 */

// Tabela 19 — Motivos de Desligamento (MOS S-2299)
export const MOTIVOS_DESLIGAMENTO = [
  { codigo: '02', descricao: 'Rescisão sem justa causa, por iniciativa do empregador' },
  { codigo: '03', descricao: 'Rescisão com justa causa, por iniciativa do empregador' },
  { codigo: '06', descricao: 'Rescisão por pedido de demissão' },
  { codigo: '07', descricao: 'Rescisão antecipada do contrato a termo por iniciativa do empregador' },
  { codigo: '08', descricao: 'Rescisão antecipada do contrato a termo por iniciativa do empregado' },
  { codigo: '09', descricao: 'Rescisão por término do contrato a termo' },
  { codigo: '10', descricao: 'Rescisão por falecimento do empregado' },
  { codigo: '11', descricao: 'Rescisão por falecimento do empregador individual' },
  { codigo: '12', descricao: 'Mudança de CPF do trabalhador' },
  { codigo: '14', descricao: 'Rescisão por culpa recíproca' },
  { codigo: '17', descricao: 'Rescisão por força maior' },
  { codigo: '21', descricao: 'Rescisão por acordo entre empregador e empregado (Lei 13.467/2017)' },
  { codigo: '27', descricao: 'Aposentadoria por idade ou tempo de contribuição (sem rescisão)' },
  { codigo: '28', descricao: 'Aposentadoria por invalidez' },
];

// Tabela 18 — Motivos de Afastamento (MOS S-2230)
export const MOTIVOS_AFASTAMENTO = [
  { codigo: '01', descricao: 'Acidente/doença do trabalho', dias_padrao: 15 },
  { codigo: '03', descricao: 'Acidente/doença NÃO relacionada ao trabalho', dias_padrao: 15 },
  { codigo: '05', descricao: 'Afastamento/licença prevista em regime próprio (estatutário)' },
  { codigo: '06', descricao: 'Aposentadoria por invalidez' },
  { codigo: '07', descricao: 'Acompanhamento — Licença para acompanhar cônjuge' },
  { codigo: '08', descricao: 'Afastamento do empregado para participar em atividade do Conselho Curador FGTS' },
  { codigo: '11', descricao: 'Cárcere / prisão' },
  { codigo: '12', descricao: 'Cargo eletivo — candidato a cargo eletivo' },
  { codigo: '13', descricao: 'Cargo eletivo — eleito para cargo eletivo' },
  { codigo: '14', descricao: 'Cessão / Requisição' },
  { codigo: '15', descricao: 'Gozo de férias / recesso', dias_padrao: 30 },
  { codigo: '16', descricao: 'Licença Maternidade', dias_padrao: 120 },
  { codigo: '17', descricao: 'Licença Maternidade — 180 dias (Empresa Cidadã)', dias_padrao: 180 },
  { codigo: '18', descricao: 'Licença Maternidade — aborto não criminoso', dias_padrao: 14 },
  { codigo: '19', descricao: 'Licença Maternidade — adoção/guarda judicial', dias_padrao: 120 },
  { codigo: '20', descricao: 'Licença não-remunerada / sem vencimentos' },
  { codigo: '21', descricao: 'Licença remunerada' },
  { codigo: '22', descricao: 'Mandato eleitoral' },
  { codigo: '23', descricao: 'Mandato sindical' },
  { codigo: '24', descricao: 'Mulher vítima de violência (Lei 11.340/2006)' },
  { codigo: '25', descricao: 'Participação em assembleia/conselho/órgão deliberativo de cooperativa' },
  { codigo: '26', descricao: 'Qualificação — Lei 11.180/2005' },
  { codigo: '27', descricao: 'Representante sindical (Lei 8.036/1990)' },
  { codigo: '28', descricao: 'Serviço militar' },
  { codigo: '29', descricao: 'Suspensão disciplinar (CLT art. 474)', dias_padrao: 30 },
  { codigo: '30', descricao: 'Suspensão MP 936/2020 ou MP 1.045/2021' },
  { codigo: '31', descricao: 'Servidor Público em disponibilidade' },
  { codigo: '33', descricao: 'Licença Paternidade', dias_padrao: 5 },
  { codigo: '34', descricao: 'Licença Paternidade — 20 dias (Empresa Cidadã)', dias_padrao: 20 },
  { codigo: '35', descricao: 'Inatividade do trabalhador avulso (sem registro de movimentação)' },
  { codigo: '36', descricao: 'Outros — situações que não se enquadrem nos códigos acima' },
];

// Tabela 1 — Categorias de Trabalhadores (MOS — usado em S-2200/S-2206)
export const CATEGORIAS_TRABALHADOR = [
  { codigo: '101', descricao: 'Empregado — Geral (CLT)' },
  { codigo: '102', descricao: 'Empregado — Trabalhador rural por pequeno prazo' },
  { codigo: '103', descricao: 'Empregado — Aprendiz' },
  { codigo: '104', descricao: 'Empregado — Doméstico' },
  { codigo: '105', descricao: 'Empregado — Contrato a Termo firmado nos termos da Lei 9.601/98' },
  { codigo: '106', descricao: 'Trabalhador temporário (Lei 6.019/74)' },
  { codigo: '111', descricao: 'Empregado — Contrato de trabalho Verde e Amarelo (Lei 13.467/2017)' },
  { codigo: '201', descricao: 'Trabalhador avulso portuário' },
  { codigo: '202', descricao: 'Trabalhador avulso não portuário' },
  { codigo: '301', descricao: 'Servidor público — Titular de cargo efetivo' },
  { codigo: '302', descricao: 'Servidor público — Ocupante de cargo exclusivo em comissão' },
  { codigo: '303', descricao: 'Agente público — Exercício de mandato eletivo' },
  { codigo: '305', descricao: 'Servidor público — Contrato temporário (Lei 8.745/93)' },
  { codigo: '410', descricao: 'Trabalhador da MEI (Microempreendedor Individual)' },
  { codigo: '701', descricao: 'Contribuinte individual — Autônomo em geral' },
  { codigo: '711', descricao: 'Contribuinte individual — Transportador autônomo de cargas' },
  { codigo: '712', descricao: 'Contribuinte individual — Transportador autônomo de passageiros' },
  { codigo: '721', descricao: 'Contribuinte individual — Diretor não empregado, sem FGTS' },
  { codigo: '722', descricao: 'Contribuinte individual — Diretor não empregado, com FGTS' },
  { codigo: '901', descricao: 'Estagiário' },
  { codigo: '903', descricao: 'Médico residente / Residente em saúde' },
  { codigo: '904', descricao: 'Bolsista' },
];

// Tabela 2 — Tipos de Lotação (MOS — usado em S-1020)
export const TIPOS_LOTACAO = [
  { codigo: '01', descricao: 'Setor, departamento, estabelecimento ou conjunto de estabelecimentos' },
  { codigo: '02', descricao: 'Tomador de serviços / Obra de construção civil sob a responsabilidade de PJ' },
  { codigo: '03', descricao: 'Obra de construção civil — responsabilidade do contratante' },
  { codigo: '06', descricao: 'Trabalho temporário — Lei 6.019/74' },
  { codigo: '07', descricao: 'Cooperativa de trabalho — Cooperados' },
  { codigo: '08', descricao: 'Operador portuário' },
  { codigo: '90', descricao: 'Atividade econômica (CAEPF)' },
  { codigo: '99', descricao: 'Outros (rural)' },
];

// Tabela 3 — Classificação Tributária (MOS — usado em S-1000)
export const CLASSIFICACAO_TRIBUTARIA = [
  { codigo: '01', descricao: 'Empresa enquadrada no regime de tributação Simples Nacional com tributação previdenciária substituída' },
  { codigo: '02', descricao: 'Empresa enquadrada no regime de tributação Simples Nacional com tributação previdenciária NÃO substituída' },
  { codigo: '03', descricao: 'Empresa enquadrada no regime de tributação Simples Nacional com tributação previdenciária substituída e NÃO substituída' },
  { codigo: '06', descricao: 'MEI — Microempreendedor Individual' },
  { codigo: '07', descricao: 'Empresário individual (não MEI) e Sociedade Empresária — Lucro Real / Presumido / Arbitrado' },
  { codigo: '08', descricao: 'Empregador Pessoa Física (CPF)' },
  { codigo: '09', descricao: 'Empregador Doméstico (CPF)' },
  { codigo: '11', descricao: 'Órgão Público — Administração Direta da União, Estados, DF, Municípios' },
  { codigo: '99', descricao: 'Demais (outros)' },
];

// Tabela 4 — Raça/Cor (MOS — usado em S-2200/S-2205)
export const RACA_COR = [
  { codigo: '1', descricao: 'Branca' },
  { codigo: '2', descricao: 'Preta' },
  { codigo: '3', descricao: 'Parda' },
  { codigo: '4', descricao: 'Amarela' },
  { codigo: '5', descricao: 'Indígena' },
  { codigo: '6', descricao: 'Não Informado' },
];

// Tabela 6 — Estado Civil (MOS — usado em S-2200/S-2205)
export const ESTADO_CIVIL = [
  { codigo: '1', descricao: 'Solteiro' },
  { codigo: '2', descricao: 'Casado' },
  { codigo: '3', descricao: 'Divorciado' },
  { codigo: '4', descricao: 'Separado' },
  { codigo: '5', descricao: 'Viúvo' },
  { codigo: '9', descricao: 'União Estável' },
];

// Tabela 5 — Grau de Instrução (MOS — usado em S-2200/S-2205)
export const GRAU_INSTRUCAO = [
  { codigo: '01', descricao: 'Analfabeto, inclusive o que, embora tenha recebido instrução, não se alfabetizou' },
  { codigo: '02', descricao: 'Até o 5º ano incompleto do Ensino Fundamental' },
  { codigo: '03', descricao: '5º ano completo do Ensino Fundamental' },
  { codigo: '04', descricao: 'Do 6º ao 9º ano do Ensino Fundamental incompleto' },
  { codigo: '05', descricao: 'Ensino Fundamental completo' },
  { codigo: '06', descricao: 'Ensino Médio incompleto' },
  { codigo: '07', descricao: 'Ensino Médio completo' },
  { codigo: '08', descricao: 'Educação Superior incompleta' },
  { codigo: '09', descricao: 'Educação Superior completa' },
  { codigo: '10', descricao: 'Pós-Graduação' },
  { codigo: '11', descricao: 'Mestrado' },
  { codigo: '12', descricao: 'Doutorado' },
];

// Sexo (eSocial)
export const SEXO = [
  { codigo: 'M', descricao: 'Masculino' },
  { codigo: 'F', descricao: 'Feminino' },
];

// Tabela 21 — Tipo de Reintegração (MOS — usado em S-2298)
export const TIPOS_REINTEGRACAO = [
  { codigo: '1', descricao: 'Reintegração por decisão/sentença judicial com efeito retroativo' },
  { codigo: '2', descricao: 'Reintegração por decisão/sentença judicial sem efeito retroativo' },
  { codigo: '3', descricao: 'Reintegração por anistia legal' },
  { codigo: '4', descricao: 'Reintegração por mudança de classificação ou enquadramento previdenciário' },
];

// Tabela 25 — Tipos de Benefícios RPPS (MOS — usado em S-2400)
export const TIPOS_BENEFICIO_RPPS = [
  { codigo: '0001', descricao: 'Aposentadoria — Tempo de Contribuição' },
  { codigo: '0002', descricao: 'Aposentadoria por Idade' },
  { codigo: '0003', descricao: 'Aposentadoria Especial' },
  { codigo: '0004', descricao: 'Aposentadoria por Invalidez' },
  { codigo: '0005', descricao: 'Aposentadoria Compulsória' },
  { codigo: '0021', descricao: 'Pensão por morte' },
  { codigo: '0099', descricao: 'Outros benefícios' },
];

// Tabela 7 — Natureza de Rubrica (MOS — usado em S-1010) — amostra das mais comuns
export const NATUREZA_RUBRICA = [
  { codigo: '1000', descricao: 'Vencimento, salário, soldo, salário-base' },
  { codigo: '1010', descricao: 'Salário-família' },
  { codigo: '1011', descricao: 'Salário-maternidade' },
  { codigo: '1020', descricao: 'Adicional de função, gratificação de função' },
  { codigo: '1100', descricao: 'Horas extras' },
  { codigo: '1101', descricao: 'Adicional noturno' },
  { codigo: '1102', descricao: 'Adicional de periculosidade' },
  { codigo: '1103', descricao: 'Adicional de insalubridade' },
  { codigo: '1200', descricao: 'DSR — Descanso Semanal Remunerado' },
  { codigo: '1500', descricao: 'Comissão' },
  { codigo: '2501', descricao: 'Prêmio (Lei 13.467/2017)' },
  { codigo: '2502', descricao: 'Abono' },
  { codigo: '3501', descricao: 'INSS — Contribuição do empregado' },
  { codigo: '3502', descricao: 'IRRF' },
  { codigo: '3503', descricao: 'FGTS — Desconto / depósito' },
  { codigo: '9100', descricao: '13º salário (proporcional)' },
  { codigo: '9200', descricao: 'Férias normais (incluindo 1/3)' },
  { codigo: '9300', descricao: 'Aviso prévio indenizado' },
  { codigo: '9400', descricao: 'Multa rescisória 40% FGTS' },
];

// Tipos de Rubrica (MOS S-1010)
export const TIPOS_RUBRICA = [
  { codigo: '1', descricao: 'Vencimento (Provento)' },
  { codigo: '2', descricao: 'Desconto' },
  { codigo: '3', descricao: 'Informativa' },
  { codigo: '4', descricao: 'Informativa dedutora' },
];

// Tabela 23 — Tipo de Processo Administrativo/Judicial (MOS S-1070)
export const TIPOS_PROCESSO = [
  { codigo: '1', descricao: 'Administrativo' },
  { codigo: '2', descricao: 'Judicial' },
  { codigo: '4', descricao: 'Notificação Fiscal' },
];

// Indicativo de Matéria do Processo (MOS S-1070)
export const INDICATIVO_MATERIA = [
  { codigo: '1', descricao: 'Tributário / FGTS' },
  { codigo: '7', descricao: 'FGTS — Lei Complementar 110/2001' },
];

// Tipos de eventos eSocial que podem ser excluídos via S-3000
export const TIPOS_EXCLUIVEIS = [
  { codigo: 'S-1200', descricao: 'S-1200 — Remuneração' },
  { codigo: 'S-1210', descricao: 'S-1210 — Pagamentos' },
  { codigo: 'S-2200', descricao: 'S-2200 — Admissão' },
  { codigo: 'S-2205', descricao: 'S-2205 — Alteração Cadastral' },
  { codigo: 'S-2206', descricao: 'S-2206 — Alteração Contratual' },
  { codigo: 'S-2210', descricao: 'S-2210 — CAT' },
  { codigo: 'S-2230', descricao: 'S-2230 — Afastamento' },
  { codigo: 'S-2298', descricao: 'S-2298 — Reintegração' },
  { codigo: 'S-2299', descricao: 'S-2299 — Desligamento' },
  { codigo: 'S-2400', descricao: 'S-2400 — Beneficiário RPPS' },
];

// Ambientes
export const AMBIENTES = [
  { codigo: '2', descricao: '2 — Produção Restrita (homologação)' },
  { codigo: '1', descricao: '1 — Produção' },
];

// Unidade salarial (MOS — usado em S-2206)
export const UNIDADE_SALARIAL = [
  { codigo: '1', descricao: 'Por hora' },
  { codigo: '2', descricao: 'Por dia' },
  { codigo: '3', descricao: 'Por semana' },
  { codigo: '4', descricao: 'Por quinzena' },
  { codigo: '5', descricao: 'Por mês' },
  { codigo: '6', descricao: 'Por tarefa' },
  { codigo: '7', descricao: 'Não aplicável (salário variável)' },
];
